import React from 'react';
import { atom, isShallowEqual } from '@reatom/framework';
import { useAtom, useCtx } from '@reatom/npm-react';
import { isObservable } from '@/js/libs/observable/index.ts';
const NEVER_VALUE = {};
// @ts-expect-error generic mismatch
export const createContexts = (contextsHook) => {
    const result = {};
    for (const [name, useContextLogic] of Object.entries(contextsHook)) {
        const hookName = `use${name}Context`;
        const providerName = `${name}Provider`;
        const context = React.createContext(NEVER_VALUE);
        const contextAtom = atom(NEVER_VALUE, `${name}Context`);
        const Provider = ({ children, value: parameter }) => {
            const state = useContextLogic(parameter);
            const value = React.useMemo(() => state, 
            // eslint-disable-next-line react-hooks/exhaustive-deps
            Object.values(state));
            const ctx = useCtx();
            if (!isShallowEqual(ctx.get(contextAtom), value)) {
                contextAtom(ctx, value);
            }
            return React.createElement(context.Provider, {
                value,
                children,
            });
        };
        Provider.displayName = providerName;
        result[hookName] = Object.assign((selector) => {
            if (selector) {
                return useAtom((ctx) => {
                    const state = ctx.spy(contextAtom);
                    const value = typeof selector === 'function' ? selector(state) : state[selector];
                    return isObservable(value) ? ctx.spy(value.__INTERNAL_DO_NOT_USE_ATOM__) : value;
                }, [], { name: `${name}.useAtom._selector` })[0];
            }
            const value = React.useContext(context);
            if (!value || value === NEVER_VALUE) {
                throw new Error(`${hookName} must be used within a ${providerName}`);
            }
            return value;
        }, {
            Provider,
        });
    }
    return result;
};
